import { TramitacioTaskNode } from "./tramitacio-task-node";

export class TramitacioIntegracioComptableNode extends TramitacioTaskNode {

}
